import { Product } from '@/data/replenishmentPlan/slice/replenishmentPlan.types.ts'

const SEPARATOR = '@'
const EMPTY_CODE = '-1'
const UNAVAILABLE_CODE = 'UNAVAILABLE'

const getPlanGroupingKey = (product: Product) => {
  if (product.unavailable) {
    return `${UNAVAILABLE_CODE}${SEPARATOR}${UNAVAILABLE_CODE}`
  }

  const groupCode = product.group?.code ?? EMPTY_CODE

  const categoryCode = product.category?.code ?? EMPTY_CODE

  return `${groupCode}${SEPARATOR}${categoryCode}`
}

const getGroupAndCategoryFromGroupingKey = (groupingKey: string) => {
  const [group, category] = groupingKey.split(SEPARATOR)

  return {
    groupCode: group === EMPTY_CODE ? null : group,
    categoryCode: category === EMPTY_CODE ? null : category,
  }
}

export { getPlanGroupingKey, getGroupAndCategoryFromGroupingKey }
